export const timeslotProfileReceived = profiles => ({
    type: 'TIMESLOT_PROFILE_RECEIVED',
    payload: profiles
});


